import { c as _c } from "react/compiler-runtime";
import { useStoreWithOptinItemsList } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-with-optin-items-list';
import { StoreId } from 'modules/stores/types/stores-interface';
import { StoreTriggerDataInterface } from '../utils/fill-trigger-with-store-data';
import { useStoreOptinItemsList } from './use-store-optin-items-list';
export const useStoreRuleData = (storeId, optinId) => {
  const $ = _c(11);
  const {
    data: stores
  } = useStoreWithOptinItemsList(true);
  let t0;
  if ($[0] !== storeId || $[1] !== stores) {
    t0 = stores?.find(store => store.id === storeId);
    $[0] = storeId;
    $[1] = stores;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const store_0 = t0;
  const {
    data: optinItems
  } = useStoreOptinItemsList(store_0?.id, true);
  let t1;
  if ($[3] !== optinId || $[4] !== optinItems) {
    t1 = optinItems?.find(item => item.id === optinId);
    $[3] = optinId;
    $[4] = optinItems;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const optinItem = t1;
  let t2;
  if ($[6] !== optinItem || $[7] !== store_0) {
    t2 = store_0 && optinItem ? {
      storeId: store_0.id,
      storeName: store_0.name,
      itemId: optinItem.id,
      itemName: optinItem.title
    } : undefined;
    $[6] = optinItem;
    $[7] = store_0;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const storeTriggerData = t2;
  let t3;
  if ($[9] !== storeTriggerData) {
    t3 = {
      storeTriggerData
    };
    $[9] = storeTriggerData;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};